import Contextmenu from "./src/index"

export default Contextmenu


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-contextmenujs/index.js
// module id = null
// module chunks = 